export default {
    updateDocument (state, payload) {
        state.document = payload
    },
    updateName (state, payload) {
        state.name = payload
    },
    updateEmail (state, payload) {
        state.email = payload
    },
    updatePhone (state, payload) {
        state.phone = payload
    },
    updateCelPhone (state, payload) {
        state.celPhone = payload
    },
}


// WEBPACK FOOTER //
// ./src/shared/modules/CustomerNew/vuex/mutations.js